
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssociateConcernFinancialsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssociateConcernFinancials"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"current_year"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"audited_years_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"years"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sales_turnover"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pat"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"equity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tnw"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nwc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"debt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tol_tnw"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"der"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":193}};
    doc.loc.source = {"body":"fragment AssociateConcernFinancialsFields on AssociateConcernFinancials {\n  id\n  current_year\n  audited_years_count\n  years\n  sales_turnover\n  pat\n  equity\n  tnw\n  nwc\n  debt\n  tol_tnw\n  der\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/graphql/fragments/AssociateConcernFinancialsFragment.graphql
// module id = 513
// module chunks = 0